import React from 'react'
import jsx1 from "./img/jsxFun.png";
import jsx2 from "./img/jsx2.png";

export default function jsx() {
  return (
    <div className="content">
        JSX is JavaScript XML, not HTML but looks like HTML, it helps produces React elements<br />
    Below image depicts how JSX  converted into JS by {" "}
    <em>
      <a href="https://babeljs.io/repl#?browsers=defaults%2C%20not%20ie%2011%2C%20not%20ie_mob%2011&build=&builtIns=false&corejs=3.21&spec=false&loose=false&code_lz=GYVwdgxgLglg9mABAZwIYFsAOAbApgCgEpEBvAKEUQCdcoQql8LLEAeAPmZbYAsBGTt26sARuwASuVABMYYAOasA9GMRRU8ri2X9BQ1rIBu7ZUb2VlewgG4yAXyA&debug=false&forceAllTransforms=false&shippedProposals=false&circleciRepo=&evaluate=false&fileSize=false&timeTravel=false&sourceType=module&lineWrap=true&presets=env%2Creact%2Cstage-2&prettier=false&targets=&version=7.18.7&externalPlugins=&assumptions=%7B%7D">
        Babel
      </a>
    </em>
    <div className="imgAlign">
      <img className="imgSize" src={jsx1}></img>
      <img className="imgSize" src={jsx2}></img>
    </div>
  </div>
  )
}
